import { Helmet } from "react-helmet-async";

export const SITE_URL = "https://aqualyxnz.co.nz";

/**
 * Reusable SEO block — sets title, canonical, description, OG, Twitter, hreflang and optional JSON-LD.
 * Children appended for any extra schema scripts.
 */
export default function Seo({
    title,
    description,
    path = "/",
    image = "https://dermalis.co.nz/aqualyx-hero.png",
    type = "website",
    breadcrumbs,
    schema,
    children,
}) {
    const url = `${SITE_URL}${path}`;
    const fullTitle = title.length > 60 ? title : title;

    const breadcrumbJsonLd = breadcrumbs
        ? {
              "@context": "https://schema.org",
              "@type": "BreadcrumbList",
              itemListElement: breadcrumbs.map((b, i) => ({
                  "@type": "ListItem",
                  position: i + 1,
                  name: b.name,
                  item: `${SITE_URL}${b.path}`,
              })),
          }
        : null;

    return (
        <Helmet>
            <title>{fullTitle}</title>
            <meta name="description" content={description} />
            <link rel="canonical" href={url} />
            <link rel="alternate" hrefLang="en-NZ" href={url} />
            <link rel="alternate" hrefLang="x-default" href={url} />
            <meta property="og:title" content={title} />
            <meta property="og:description" content={description} />
            <meta property="og:url" content={url} />
            <meta property="og:type" content={type} />
            <meta property="og:image" content={image} />
            <meta property="og:locale" content="en_NZ" />
            <meta property="og:site_name" content="Aqualyx New Zealand" />
            <meta name="twitter:card" content="summary_large_image" />
            <meta name="twitter:title" content={title} />
            <meta name="twitter:description" content={description} />
            <meta name="twitter:image" content={image} />
            {breadcrumbJsonLd && (
                <script type="application/ld+json">{JSON.stringify(breadcrumbJsonLd)}</script>
            )}
            {schema && (
                <script type="application/ld+json">{JSON.stringify(schema)}</script>
            )}
            {children}
        </Helmet>
    );
}
